import api from "../../../api";
import router from "../../../router";
import { disablePush } from "../../../utils/pushNotifications";

export default {
  async getMySelf({ commit }) {
    commit("REQUEST_MYSELF");
    commit("SET_LOADING", true, { root: true });
    try {
      commit("SUCCESS_REQUEST_MYSELF", await api.mySelf());
    } catch (err) {
      commit("TO_LOGIN", true, { root: true });
      //commit("FAILURE_REQUEST_MYSELF");
    } finally {
      commit("SET_LOADING", false, { root: true });
    }
  },
  async authenticate({ commit }, { email, password }) {
    window.sessionStorage.removeItem("SupportAuthorization");
    window.sessionStorage.removeItem("SupportWindow");
    commit("REQUEST_AUTH");
    commit("SET_LOADING", true, { root: true });
    try {
      const authResponse = await api.authenticate({ email, password });
      const { token, expiresAt } = authResponse.body;

      window.localStorage.setItem("Authorization", token);

      const mySelfResponse = await api.mySelf();
      if (!mySelfResponse?.body?.obs_user) {
        window.localStorage.removeItem("Authorization");
        commit("FAILURE_REQUEST_MYSELF");
        commit("FAILURE_REQUEST_AUTH", {
          message: "OBS access is not enabled for this user.",
        });
        return;
      }

      commit("SUCCESS_REQUEST_AUTH", { body: { token, expiresAt } });
      commit("SUCCESS_REQUEST_MYSELF", mySelfResponse);
    } catch (err) {
      window.localStorage.removeItem("Authorization");
      console.log("Error in Auth");
      console.log(JSON.stringify(err));
      commit("FAILURE_REQUEST_AUTH", {
        message: "E-Mail or password incorrect.",
      });
    } finally {
      commit("SET_LOADING", false, { root: true });
    }
  },
  async logout({ commit }) {
    if (window.sessionStorage.getItem("SupportAuthorization")) {
      try {
        await api.endSupportSession();
      } catch (err) {
        // The support token may already be expired or revoked.
      }
      window.sessionStorage.removeItem("SupportAuthorization");
      commit("CLEAR_AUTH");
      window.close();
      return;
    }
    try {
      await disablePush();
    } catch (err) {
      // Logout must still succeed if a push service is temporarily unavailable.
    }
    window.localStorage.removeItem("Authorization");
    commit("CLEAR_AUTH");
    //window.location.reload();
    router.push({name: "login"});
  }
};
